<template>
  <div class="game-filter__icon">
    <div class="game-filter__icon__image">
      <svg v-if="icon === 'filter-regions'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26"><path :fill="color" d="M13 .33a12.88 12.88 0 0 1 .85.03 12.67 12.67 0 0 1-.3 25.3H13a12.88 12.88 0 0 1-.86-.02 12.67 12.67 0 0 1 .31-25.3H13Zm2.94 17.34h-5.88c.5 2.31 1.39 4.57 2.64 6.66h.6l-.2.32a21.97 21.97 0 0 0 2.84-6.98Zm-7.24 0H2.67a11.35 11.35 0 0 0 8.4 6.5 23.28 23.28 0 0 1-2.37-6.5Zm14.63 0H17.3a23.3 23.3 0 0 1-2.38 6.5c3.65-.62 6.7-2.98 8.27-6.2l.14-.3Zm-14.86-8h-6.3a11.33 11.33 0 0 0 0 6.66h6.3a23.36 23.36 0 0 1 0-6.66Zm7.71 0H9.82c-.34 2.2-.34 4.45 0 6.66h6.36c.34-2.2.34-4.45 0-6.66Zm7.66 0h-6.3c.31 2.2.31 4.45 0 6.66h6.3a11.33 11.33 0 0 0 0-6.66ZM11.08 1.83l-.09.01a11.35 11.35 0 0 0-8.32 6.5H8.7a23.3 23.3 0 0 1 2.38-6.51ZM13 1.67h-.3l.2-.32a21.97 21.97 0 0 0-2.84 6.98h5.88a21.97 21.97 0 0 0-2.64-6.66H13Zm1.92.16.2.35a23.3 23.3 0 0 1 2.18 6.15h6.03a11.35 11.35 0 0 0-8.4-6.5Z"/></svg>
      <svg v-else-if="icon === 'filter-game-type'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 30"><path :fill="color" d="M31.46 11.34a.87.87 0 0 0-.7-.6L21.1 9.35 16.74.48a.86.86 0 0 0-.77-.48.86.86 0 0 0-.77.49l-4.3 8.9-9.66 1.45a.87.87 0 0 0-.48 1.48l7.02 6.9-1.62 9.76a.86.86 0 0 0 1.25.92l8.63-4.64 8.66 4.59c.13.06.26.1.4.1a.87.87 0 0 0 .83-1.08l-1.67-9.7 6.97-6.94a.86.86 0 0 0 .23-.9Zm-8.72 6.9c-.2.2-.3.5-.24.78l1.46 8.46-7.52-3.97a.86.86 0 0 0-.8 0l-7.5 4.02 1.4-8.48a.88.88 0 0 0-.24-.77L3.2 12.3l8.4-1.27a.85.85 0 0 0 .64-.47l3.73-7.72 3.78 7.7c.12.26.37.43.65.47l8.4 1.22-6.07 6.01Z"/></svg>
      <svg v-else-if="icon === 'filter-game-theme'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><path :fill="color" d="M17.31.26a.88.88 0 0 1 1.16-.08l.09.08 11.18 11.18a.88.88 0 0 1 .08 1.16l-.08.09-8.66 8.66a3.5 3.5 0 0 1-4.82.15l-.22-.22-.42-.41c-.41-.42-1.1-.25-1.61-.04-1.75.72-3.46 2.84-3.46 3.9A5.24 5.24 0 0 1 5.27 30a5.24 5.24 0 0 1-5.26-5.01L0 24.73v-.22a5.28 5.28 0 0 1 5.27-5.06c1.39 0 4.12-2.67 4.12-4.4a.9.9 0 0 0-.26-.67l-.48-.48a3.5 3.5 0 0 1-.15-4.82l.15-.16L17.3.26Zm-4.35 6.83L9.9 10.17c-.33.33-.51.77-.51 1.24 0 .41.14.8.4 1.11l.11.13.49.49c.5.5.77 1.17.77 1.92 0 1.4-.87 2.71-1.54 3.52l-.22.25-.1.11-.18.19c-1.18 1.23-2.53 1.99-3.63 2.07l-.2.01a3.52 3.52 0 1 0 3.5 3.73v-.21c0-2.05 2.45-4.66 4.56-5.53 1.41-.58 2.67-.43 3.52.42l.49.49c.33.33.77.51 1.24.51.41 0 .8-.14 1.12-.4l.12-.11 3.08-3.07-9.95-9.95ZM5.27 23.85a.88.88 0 1 1 0 1.76.88.88 0 0 1 0-1.76ZM17.93 2.12l-3.72 3.73 9.94 9.94 3.73-3.72-9.95-9.95Z"/></svg>
      <svg v-else-if="icon === 'filter-volatility'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 26"><path :fill="color" d="M26.105 0a2.89 2.89 0 0 0-2.9 2.878c0 .75.288 1.472.815 2.008l-5.297 10.557a2.39 2.39 0 0 0-.35-.034c-.375 0-.749.074-1.094.215l-4.113-4.61c.238-.423.368-.897.374-1.388a2.893 2.893 0 0 0-2.9-2.889 2.893 2.893 0 0 0-2.901 2.889 2.86 2.86 0 0 0 .713 1.873l-5.036 8.774a2.661 2.661 0 0 0-.515-.05A2.893 2.893 0 0 0 0 23.11 2.893 2.893 0 0 0 2.9 26c1.604 0 2.901-1.292 2.901-2.889a2.86 2.86 0 0 0-.714-1.873l5.031-8.774c.538.107 1.099.05 1.603-.164l4.113 4.61a2.904 2.904 0 0 0-.368 1.388 2.897 2.897 0 0 0 2.89 2.9 2.897 2.897 0 0 0 2.911-2.877c0-.75-.289-1.479-.816-2.02l5.297-10.557c.113.017.232.034.351.034A2.888 2.888 0 1 0 26.105 0Z"/></svg>
      <svg v-else-if="icon === 'filter-partners'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 25"><path :fill="color" d="m1.38 0 .6.04.79.06.92.09.66.07.69.09.7.1c1.88.3 3.76.75 4.5 1.44.19.18.28.43.26.68l-.09.76h6.67c2.08-1.64 3.96-2.08 6.8-.88l1.1.48.8.34.78.32 1.1.44.99.39.3.11a.83.83 0 0 1 .29-1.06l.12-.07.33-.14.5-.18.25-.09.45-.14.34-.1.57-.16.42-.1.45-.1.23-.06.5-.1.26-.05.55-.1c.56-.08 1.17-.17 1.82-.23l.67-.06.7-.05.72-.04c.5-.02 1.01-.03 1.55-.03.42 0 .77.31.82.72l.01.1V17.5c0 .42-.32.78-.73.83h-5.1a.83.83 0 0 1-.8-.6l-.18-.59a42.2 42.2 0 0 0-.05-.17l-1.32.88c.18.94-.14 1.88-.9 2.53-.57.49-1.25.72-1.92.69-.24.6-.72 1.11-1.39 1.45-.68.34-1.43.44-2.09.3-.35.72-.97 1.31-1.73 1.6a2.6 2.6 0 0 1-1.9.02c-.44.37-1.07.56-1.89.56-.96 0-2.17-.5-2.83-.89l-.2-.12-.51-.37-.78-.57-1.2-.92-1.17-.9-1.52-1.2-1.04-.83-1.03-.85-.26-.21c-.2-.18-.45-.4-.72-.67l-.42-.43-1.5-1.56-.2.61c-.1.3-.36.52-.67.57H1.33a.83.83 0 0 1-.82-.72l-.01-.1v-15A.83.83 0 0 1 1.38 0Zm13.86 5h-5.1C9.93 6 9.68 7.1 9.4 8.2l-.28 1.09-.14.54-.3 1.05-.28 1-.4 1.39c-.05.14-.1.28-.13.42l.25.25.3.3.53.54.75.78.38.39.35.36.17.16.3.28.13.11.49.4.75.63 1.02.82 1.25.98 1.58 1.23L17.57 22l.77.55.12.08c.49.33 1.48.7 2.04.7.16 0 .3 0 .4-.02l-.2-.18-.6-.59-.82-.83-1.12-1.16-.77-.81a.83.83 0 0 1 1.22-1.14l1.06 1.12.91.93.58.59.56.55.36.34.33.3.32.28c.33.31.7.25.96.16.4-.16.73-.5.89-.9l-.27-.25-.45-.42-.63-.62-.63-.64-1.25-1.3-.63-.68a.83.83 0 0 1 1.23-1.12l.73.78.54.57.81.83.62.62.4.39.36.35.33.3.15.13.17.14c.22.2.77.25 1.3-.02.18-.09.53-.3.62-.66l-.3-.3-.78-.74-.88-.88-.9-.93-1.89-1.94a.83.83 0 1 1 1.2-1.16l1.74 1.8 1.4 1.42.88.87.54.52.21.19.15.13-.02-.02c.25.15.68.06 1-.22l.1-.1c.21-.21.42-.6.15-1.15a7.52 7.52 0 0 0-1.49-1.8l-.4-.39-.44-.4-.46-.4-.72-.62-.76-.63-.79-.64-1.6-1.3-.77-.63a43.05 43.05 0 0 1-2.02-1.75l-.46.2-.12.05c-.43.2-.72.32-1.25.4-1.29 1.7-3 2.3-4.9 1.67a2.06 2.06 0 0 1-1.43-1.5c-.38-1.63 1.04-3.83 2.16-5l.11-.12Zm23.6-1.66c-1.42.04-2.68.15-3.77.3l-.64.1-.3.06-.57.1-.53.12-.5.1-.44.12-.4.11-.37.11-.46.15c.1.18.18.39.28.6l.3.7.3.77.34.84.34.88.34.91.34.93.5 1.4.63 1.81.42 1.24.36 1.09.28.89h3.54V3.34Zm-15.35.75c-2.61-1.16-4-.76-6.17 1.22l-.43.41-.45.44C15.3 7.3 14.42 9.01 14.6 9.74c.02.1.07.22.33.3l.18.06c.81.23 1.94.24 3.03-1.4.14-.2.36-.34.61-.36.44-.04.62-.1.87-.2l.6-.26.28-.12.35-.13.2-.08c.3-.1.64-.03.87.2.35.35.78.73 1.26 1.15l.6.5.97.8L27 12.03l.7.58.34.28.66.57a20.37 20.37 0 0 1 2.88 2.88l1.53-1.02-.3-.88-.32-.94-.35-.99-.36-1-.45-1.25-.36-.97-.35-.93-.35-.88c-.1-.28-.22-.55-.32-.8l-1-.37-.6-.22-.94-.36-1.34-.54-.86-.35-.6-.25-.59-.26-.53-.24ZM2.17 1.73V15h3.55l.43-1.37.38-1.24.41-1.44.22-.77.22-.8.21-.8.31-1.21.2-.81.17-.8.17-.76c.15-.76.27-1.47.35-2.1-.3-.13-.74-.27-1.27-.4l-.49-.11a21.5 21.5 0 0 0-.26-.06l-.54-.1-.58-.1-.6-.09-.63-.08-.32-.04-.64-.07-.32-.04-.65-.06-.32-.02Z"/></svg>
			<svg v-else-if="icon === 'filter-search'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16"> <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/> </svg>
		 	<svg v-else-if="icon === 'filter-more'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 5"><path :fill="color" d="M26.5 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm-12 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm-12 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z"/></svg>
      <span v-else>No icon defined.</span>
    </div>

    <span
      v-if="badge"
      class="game-filter__icon__badge"
    >
      {{ typeof badge === 'number' ? badge : '' }}
    </span>

    <div
      class="game-filter__icon__title"
      :class="{
        'game-filter__icon__title--active': active || badge
      }"
    >{{ title }}</div>
    <div class="game-filter-down">
      <svg xmlns="http://www.w3.org/2000/svg"><path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/></svg>
    </div>
  </div>
</template>

<script>

export default {
	name: 'GameFilterIcon',
  components: {

  },
  computed: {
	  color() {
	    return this.active || this.badge ? '#0179ff ' : '#666'
    }
  },
	props: {
	  icon: {
	    type: String,
      default: null
    },
    title: {
	    type: String,
      default: 'No title'
    },
    badge: {
	    type: [Boolean, Number],
      default: 0
    },
    active: {
	    type: Boolean,
      default: false
    }
	}
}
</script>

<style scoped lang="scss">
@import "src/scss/toolkit";

.game-filter__icon {
  position: relative;
  background: palette(white);

	@include media(phab) {
		padding: 1rem;
		margin-top: 0.5rem;
		border: 1px solid palette('divider');
		border-radius: 0.25rem;
		display: flex;
		align-items: center;
	}

	@include media(not-phab) {
		padding: 1.5rem 2.5rem;
		text-align: center;
	}

  &__image {
		height: 2rem;

		@include media(phab) {
			display: flex;
			align-items: center;
		}

    svg {
			width: 2rem;

			@include media(phab) {
				margin-right: 0.75rem;
			}

			@include media(not-phab) {
				width: auto;
				max-height: 100%;
			}
    }
  }

  &__badge {
    position: absolute;
    top: 1rem;
    right: calc(50% - 1.25rem);
    font-size: .625em;
    @include extend(badge);
    @include extend(bgc-pal--red);
    @include extend(lato-bold);
  }

  &__title {
    text-transform: uppercase;
    @include extend(lato-bold);

		@include media(not-phab) {
			padding-top: .5rem;
			font-size: .625rem;
		}
    &--active {
      color: palette(blue)
    }
  }
}
.game-filter-down{
  display: none;
}

@media(max-width:767px){
  .game-filter-down{
    display: block;
    position: absolute;
    right:22px;
  }
  .game-filter-down svg{
    width: 20px;
    height: 20px;
    fill: #0179FF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/GameFilterIcon.vue